<div class="container-fluid psp-container">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/prescription-fulfillment'"
    [currentPageValue]="'Prescription Details'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="prescription-details-container">
      <div class="card-body">
        <div class="border-bottom title pb-2">
          <h2 class="m-0">Prescription Details</h2>
        </div>

        <div class="details-section mt-4">
          <h2>Patient Personal Details</h2>
          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Full Name</h5>
              <h4 class="prop-value">
                {{ patientPersonalInfo?.fullName || "--" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">National ID</h5>
              <h4 class="prop-value">
                {{ patientPersonalInfo?.nationalId || "--" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Phone Number</h5>
              <h4 class="prop-value">
                {{ patientPersonalInfo?.phone || "--" }}
              </h4>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="details-section mt-4">
          <h2>Request Information</h2>
          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Request ID</h5>
              <h4 class="prop-value">
                {{ requestInformation?.requestId || "--" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Request Date</h5>
              <h4 class="prop-value">
                {{ requestInformation?.requestDate?.split("T")[0] || "--" }}
              </h4>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Includes Medication</h5>
              <h4 class="prop-value">
                {{ medication ? "Yes" : "No" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Includes Tests</h5>
              <h4 class="prop-value">
                {{ labTests == null ? "No" : "Yes" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Includes Radiologies</h5>
              <h4 class="prop-value">
                {{ radiologyTests == null ? "No" : "Yes" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Includes Procedures</h5>
              <h4 class="prop-value">
                {{ hospitalProcedures == null ? "No" : "Yes" }}
              </h4>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Test Location</h5>
              <h4 class="prop-value">
                {{ checkTestLocation(requestInformation?.isAtHome) }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Lab Name</h5>
              <h4 class="prop-value">
                {{ requestInformation?.labName || "--" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Branch</h5>
              <h4 class="prop-value">
                {{ requestInformation?.branchName || "--" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Branch Number</h5>
              <h4 class="prop-value">
                {{ requestInformation?.branchNumber || "--" }}
              </h4>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="details-section mt-4">
          <h2>Selected Address</h2>
          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">City</h5>
              <h4 class="prop-value">
                {{ selectedAddresses?.city || "--" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Area</h5>
              <h4 class="prop-value">
                {{ selectedAddresses?.area || "--" }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Address</h5>
              <h4 class="prop-value">
                {{ selectedAddresses?.address || "--" }}
              </h4>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="details-section mt-4 mb-4">
          <h2>Uploaded Prescription</h2>
          <div *ngIf="uploadedPrescriptions?.length" class="row">
            <div
              *ngFor="let prescription of uploadedPrescriptions"
              class="col-xs-6 col-sm-3 prop"
            >
              <button (click)="handleOpenfile($event, prescription)">
                <img src="../../../../assets/file-icon.png" alt="file icon" />
                <span>{{ prescription.split("/").pop() }}</span>
              </button>
            </div>
          </div>
          <div *ngIf="!uploadedPrescriptions?.length">
            <h4>There is no uploaded prescriptions</h4>
          </div>
        </div>

        <div class="divider"></div>

        <div class="details-section mt-4">
          <h2>Additional Medicines</h2>
          <div class="row">
            <div class="col-12 prop">
              <h5 class="prop-key">Medicines Name</h5>
              <h4 class="prop-value">
                {{ additionalMedications || "--" }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <h2>Request Status</h2>
  <div class="card mb-4">
    <div class="request-status-container">
      <div class="card-body">
        <div class="details-section" *ngIf="medication">
          <div class="medication-title">
            <h2 class="mr-2">Medication</h2>
            <button
              placement="top"
              tooltip="Edit Medication Status"
              (click)="editMedicationStatus($event, prescriptionFulfillmentTypeEnum.Medicine)"
              [disabled]="
                !medication ||
                medication?.requestStatus ==
                  prescriptionRequestStatusEnum.Finished
              "
            >
              <span class="btn-inner--icon">
                <i class="fas fa-pen"></i>
              </span>
            </button>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Request Status</h5>
              <h4 class="prop-value">
                {{ handleRequestStatus(medication?.requestStatus) }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Processed On</h5>
              <h4 *ngIf="medication?.processedDate" class="prop-value">
                {{ handleDate(medication?.processedDate) }}
              </h4>
              <h4 *ngIf="!medication?.processedDate" class="prop-value">--</h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Closed On</h5>
              <h4 *ngIf="medication?.closedDate" class="prop-value">
                {{ handleDate(medication?.closedDate) }}
              </h4>
              <h4 *ngIf="!medication?.closedDate" class="prop-value">--</h4>
            </div>
          </div>
        </div>

        <div class="divider" *ngIf="labTests && medication"></div>
        <div [ngClass]="{'details-section': true, 'mt-4': medication}" *ngIf="labTests">
          <div class="lab-tests-title">
            <h2 class="mr-2">Lab Tests</h2>
            <button
              placement="top"
              tooltip="Edit Lab Tests Status"
              (click)="editLabTestsStatus($event)"
              [disabled]="
                !labTests ||
                labTests?.requestStatus ==
                  prescriptionRequestStatusEnum.Finished
              "
            >
              <span class="btn-inner--icon">
                <i class="fas fa-pen"></i>
              </span>
            </button>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Request Status</h5>
              <h4 class="prop-value">
                {{ handleRequestStatus(labTests?.requestStatus) }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Processed On</h5>
              <h4 *ngIf="labTests?.processedDate" class="prop-value">
                {{ handleDate(labTests?.processedDate) }}
              </h4>
              <h4 *ngIf="!labTests?.processedDate" class="prop-value">--</h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Closed On</h5>
              <h4 *ngIf="labTests?.closedDate" class="prop-value">
                {{ handleDate(labTests?.closedDate) }}
              </h4>
              <h4 *ngIf="!labTests?.closedDate" class="prop-value">--</h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Tests Results</h5>
              <a
                href="javascript:void(0)"
                class="prop-value"
                (click)="onUploadPrescriptionResult(labTests,
                  prescriptionFulfillmentTypeEnum.LabTest)"
                [class.disabled-link]="!labTests"
                >Upload/View Files</a
              >
            </div>
          </div>
        </div>

        <div class="divider" *ngIf="radiologyTests && (labTests || medication)"></div>
        <div [ngClass]="{'details-section': true, 'mt-4': labTests || medication}" *ngIf="radiologyTests">
          <div class="lab-tests-title">
            <h2 class="mr-2">Radiology Tests</h2>
            <button
              placement="top"
              tooltip="Edit Lab Tests Status"
              (click)="editMedicationStatus($event, prescriptionFulfillmentTypeEnum.Radiology)"
              [disabled]="
                !radiologyTests ||
                radiologyTests?.requestStatus ==
                  prescriptionRequestStatusEnum.Finished
              "
            >
              <span class="btn-inner--icon">
                <i class="fas fa-pen"></i>
              </span>
            </button>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Request Status</h5>
              <h4 class="prop-value">
                {{ handleRequestStatus(radiologyTests?.requestStatus) }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Processed On</h5>
              <h4 *ngIf="radiologyTests?.processedDate" class="prop-value">
                {{ handleDate(radiologyTests?.processedDate) }}
              </h4>
              <h4 *ngIf="!radiologyTests?.processedDate" class="prop-value">--</h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Closed On</h5>
              <h4 *ngIf="radiologyTests?.closedDate" class="prop-value">
                {{ handleDate(radiologyTests?.closedDate) }}
              </h4>
              <h4 *ngIf="!radiologyTests?.closedDate" class="prop-value">--</h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Tests Results</h5>
              <a
                href="javascript:void(0)"
                class="prop-value"
                (click)="onUploadPrescriptionResult(radiologyTests,
                  prescriptionFulfillmentTypeEnum.Radiology)"
                [class.disabled-link]="!radiologyTests"
                >Upload/View Files</a
              >
            </div>
          </div>
        </div>

        <div class="divider" *ngIf="hospitalProcedures && (labTests || medication || radiologyTests)"></div>
        <div [ngClass]="{'details-section': true, 'mt-4': labTests || medication || radiologyTests}" class="details-section" *ngIf="hospitalProcedures">
          <div class="medication-title">
            <h2 class="mr-2">Procedures</h2>
            <button
              placement="top"
              tooltip="Edit hospitalProcedures Status"
              (click)="editMedicationStatus($event, prescriptionFulfillmentTypeEnum.HospitalProcedure)"
              [disabled]="
                !hospitalProcedures ||
                hospitalProcedures?.requestStatus ==
                  prescriptionRequestStatusEnum.Finished
              "
            >
              <span class="btn-inner--icon">
                <i class="fas fa-pen"></i>
              </span>
            </button>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Request Status</h5>
              <h4 class="prop-value">
                {{ handleRequestStatus(hospitalProcedures?.requestStatus) }}
              </h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Processed On</h5>
              <h4 *ngIf="hospitalProcedures?.processedDate" class="prop-value">
                {{ handleDate(hospitalProcedures?.processedDate) }}
              </h4>
              <h4 *ngIf="!hospitalProcedures?.processedDate" class="prop-value">--</h4>
            </div>
            <div class="col-xs-6 col-sm-3 prop">
              <h5 class="prop-key">Closed On</h5>
              <h4 *ngIf="hospitalProcedures?.closedDate" class="prop-value">
                {{ handleDate(hospitalProcedures?.closedDate) }}
              </h4>
              <h4 *ngIf="!hospitalProcedures?.closedDate" class="prop-value">--</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
